const tableTemplate = {
  name: "醫療紀錄單",
  template: {
    type: "box",
    layout: "column",
    id: 0,
    contents: [
      {
        type: "box",
        id: 1,
        contents: [
          {
            type: "text",
            id: 2,
            text: "醫療紀錄單",
            fontSize: "1.25rem",
            fontWeight: "normal",
          },
        ],
        marginBottom: "5px",
      },
      {
        type: "table",
        id: 3,
        contents: [
          {
            type: "trow",
            id: 4,
            contents: [
              {
                type: "tcol",
                id: 5,
                width: "16.6%",
                contents: [
                  {
                    type: "text",
                    id: 6,
                    text: "患者",
                    fontStyle: "",
                    textAlign: "center",
                    color: "#02B1E7",
                    fontWeight: "bold",
                  },
                ],
                backgroundColor: "#F0FBFF",
              },
              {
                type: "tcol",
                id: 7,
                width: "16.6%",
                contents: [
                  {
                    type: "textField",
                    id: 8,
                    width: "auto",
                    bindingKey: "patientName",
                  },
                ],
              },
              {
                type: "tcol",
                id: 9,
                width: "16.6%",
                contents: [
                  {
                    type: "text",
                    id: 10,
                    text: "醫師",
                    width: "",
                    textAlign: "center",
                    fontWeight: "bold",
                    color: "#02B1E7",
                  },
                ],
                backgroundColor: "#F0FBFF",
              },
              {
                type: "tcol",
                id: 11,
                width: "16.6%",
                contents: [
                  {
                    type: "textField",
                    id: 12,
                    width: "auto",
                    bindingKey: "visitorName",
                  },
                ],
              },
              {
                type: "tcol",
                id: 13,
                width: "16.6%",
                contents: [
                  {
                    type: "text",
                    id: 14,
                    text: "記錄人員",
                    textAlign: "center",
                    color: "#02B1E7",
                    fontWeight: "bold",
                  },
                ],
                backgroundColor: "#F0FBFF",
              },
              {
                type: "tcol",
                id: 15,
                width: "16.6%",
                contents: [
                  {
                    type: "textField",
                    id: 16,
                    width: "auto",
                    bindingKey: "partnerName",
                  },
                ],
              },
            ],
          },
          {
            type: "trow",
            id: 17,
            contents: [
              {
                type: "tcol",
                id: 18,
                contents: [
                  {
                    type: "text",
                    id: 19,
                    text: "訪問日時",
                    textAlign: "center",
                    color: "#02B1E7",
                    fontWeight: "bold",
                  },
                ],
                width: "16.6%",
                backgroundColor: "#F0FBFF",
              },
              {
                type: "tcol",
                id: 20,
                colspan: "3",
                contents: [
                  {
                    type: "box",
                    id: 21,
                    contents: [
                      {
                        type: "datePicker",
                        id: 22,
                        locale: "ja",
                        style: "outlined",
                        dense: true,
                        bindingKey: "visitDatePicker",
                        width: "",
                        label: "日期",
                        marginRight: "20px",
                        grow: 0,
                        shrink: 1,
                      },
                      {
                        type: "timeIntervalSelect",
                        id: 23,
                        time: [
                          "時間",
                          "00:00",
                          "00:30",
                          "01:00",
                          "01:30",
                          "02:00",
                          "02:30",
                          "03:00",
                          "03:30",
                          "04:00",
                          "04:30",
                          "05:00",
                          "05:30",
                          "06:00",
                          "06:30",
                          "07:00",
                          "07:30",
                          "08:00",
                          "08:30",
                          "09:00",
                          "09:30",
                          "10:00",
                          "10:30",
                          "11:00",
                          "11:30",
                          "12:00",
                          "12:30",
                          "13:00",
                          "13:30",
                          "14:00",
                          "14:30",
                          "15:00",
                          "15:30",
                          "16:00",
                          "16:30",
                          "17:00",
                          "17:30",
                          "18:00",
                          "18:30",
                          "19:00",
                          "19:30",
                          "20:00",
                          "20:30",
                          "21:00",
                          "21:30",
                          "22:00",
                          "22:30",
                          "23:00",
                          "23:30",
                        ],
                        dense: true,
                        width: "",
                        bindingKey: "visitTimeInterval",
                        grow: 0,
                        shrink: 1,
                        style: "outlined",
                      },
                    ],
                    flexShrink: 0,
                    wrap: false,
                    flexGrow: 0,
                  },
                ],
              },
              {
                type: "tcol",
                id: 24,
                colspan: "2",
                contents: [
                  {
                    type: "box",
                    id: 25,
                    layout: "",
                    contents: [
                      {
                        type: "box",
                        id: 26,
                        contents: [
                          {
                            type: "text",
                            id: 27,
                            text: "室温",
                            flexBasis: "auto",
                            shrink: 0,
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                          {
                            type: "textField",
                            id: 28,
                            width: "",
                            bindingKey: "roomTemperature",
                            grow: 0,
                            shrink: 1,
                          },
                          {
                            type: "text",
                            id: 29,
                            text: "℃",
                            flexBasis: "auto",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        ],
                        flexGrow: 0,
                        flexShrink: 1,
                        marginRight: "20px",
                      },
                      {
                        type: "box",
                        id: 30,
                        contents: [
                          {
                            type: "text",
                            id: 31,
                            text: "湿度",
                            flexBasis: "auto",
                            grow: 0,
                            shrink: 0,
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                          {
                            type: "textField",
                            id: 32,
                            width: "",
                            bindingKey: "roomHumidity",
                            grow: 0,
                            shrink: 1,
                          },
                          {
                            type: "text",
                            id: 33,
                            text: "%",
                            flexBasis: "auto",
                            grow: 0,
                            shrink: 0,
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        ],
                        flexGrow: 0,
                        flexShrink: 1,
                      },
                    ],
                    wrap: false,
                    fillHeight: false,
                    alignItems: "align-center",
                  },
                ],
                width: "16.6%",
              },
            ],
          },
        ],
      },
      {
        type: "table",
        id: 34,
        contents: [
          {
            type: "trow",
            id: 35,
            contents: [
              {
                type: "tcol",
                id: 36,
                contents: [
                  {
                    type: "text",
                    id: 37,
                    text: "體溫",
                    textAlign: "center",
                    grow: 1,
                    shrink: 1,
                    fontWeight: "bold",
                    color: "#02B1E7",
                  },
                ],
                backgroundColor: "#F0FBFF",
              },
              {
                type: "tcol",
                id: 38,
                contents: [
                  {
                    type: "text",
                    id: 39,
                    textAlign: "center",
                    text: "脈搏",
                    color: "#02B1E7",
                    fontWeight: "bold",
                  },
                ],
                backgroundColor: "#F0FBFF",
              },
              {
                type: "tcol",
                id: 40,
                contents: [
                  {
                    type: "text",
                    id: 41,
                    text: "血壓",
                    textAlign: "center",
                    color: "#02B1E7",
                    fontWeight: "bold",
                  },
                ],
                backgroundColor: "#F0FBFF",
              },
              {
                type: "tcol",
                id: 42,
                contents: [
                  {
                    type: "text",
                    id: 43,
                    text: "呼吸",
                    textAlign: "center",
                    color: "#02B1E7",
                    fontWeight: "bold",
                  },
                ],
                backgroundColor: "#F0FBFF",
              },
              {
                type: "tcol",
                id: 44,
                contents: [
                  {
                    type: "text",
                    id: 45,
                    text: "SpO2",
                    textAlign: "center",
                    color: "#02B1E7",
                    fontWeight: "bold",
                  },
                ],
                backgroundColor: "#F0FBFF",
              },
            ],
          },
          {
            type: "trow",
            id: 46,
            contents: [
              {
                type: "tcol",
                id: 47,
                contents: [
                  {
                    type: "textField",
                    id: 48,
                    bindingKey: "bodyTemperature",
                  },
                ],
              },
              {
                type: "tcol",
                id: 49,
                contents: [
                  {
                    type: "textField",
                    id: 50,
                    bindingKey: "pulseInput",
                    marginBottom: "20px",
                  },
                  {
                    type: "box",
                    id: 51,
                    contents: [
                      {
                        type: "radioGroup",
                        id: 52,
                        contents: [
                          {
                            type: "radio",
                            id: 53,
                            label: "良好",
                          },
                          {
                            type: "radio",
                            id: 54,
                            label: "不良",
                          },
                        ],
                        dense: true,
                        direction: "row",
                        bindingKey: "bloodPressureRadio",
                        shrink: 1,
                        grow: 0,
                      },
                    ],
                    alignItems: "align-center",
                    wrap: true,
                  },
                ],
              },
              {
                type: "tcol",
                id: 55,
                contents: [
                  {
                    type: "box",
                    id: 56,
                    layout: "column",
                    contents: [
                      {
                        type: "text",
                        id: 57,
                        text: "最高 / 最低",
                        flexBasis: "auto",
                        shrink: 0,
                        grow: 0,
                        color: "rgba(0, 0, 0, 0.6)",
                      },
                      {
                        type: "textField",
                        id: 58,
                        shrink: 1,
                        flex: "",
                        flexBasis: "",
                        width: "",
                        bindingKey: "bloodPressure",
                        grow: 0,
                      },
                    ],
                    wrap: false,
                    alignItems: "align-start",
                  },
                ],
              },
              {
                type: "tcol",
                id: 59,
                contents: [
                  {
                    type: "textField",
                    id: 60,
                    bindingKey: "breatheInput",
                    marginBottom: "20px",
                  },
                  {
                    type: "box",
                    id: 61,
                    contents: [
                      {
                        type: "radioGroup",
                        id: 62,
                        contents: [
                          {
                            type: "radio",
                            id: 63,
                            label: "良好",
                          },
                          {
                            type: "radio",
                            id: 64,
                            label: "不良",
                          },
                        ],
                        direction: "row",
                        dense: true,
                        bindingKey: "breatheAirRadio",
                        shrink: 1,
                        grow: 0,
                      },
                    ],
                    alignItems: "align-center",
                    marginRight: "10px",
                    wrap: true,
                  },
                ],
              },
              {
                type: "tcol",
                id: 65,
                contents: [
                  {
                    type: "textField",
                    id: 66,
                    bindingKey: "spO2Input",
                  },
                ],
              },
            ],
          },
          {
            type: "trow",
            id: 67,
            contents: [
              {
                type: "tcol",
                id: 68,
                contents: [
                  {
                    type: "textarea",
                    id: 69,
                    style: "outlined",
                    dense: true,
                    bindingKey: "textarea",
                  },
                ],
                colspan: "5",
              },
            ],
          },
        ],
      },
    ],
  },
  bindingData: {
    patientName: null,
    visitorName: null,
    partnerName: null,
    visitDatePicker: null,
    visitTimeInterval: "時間",
    roomTemperature: null,
    roomHumidity: null,
    bodyTemperature: null,
    pulseInput: null,
    bloodPressureRadio: null,
    bloodPressure: null,
    breatheInput: null,
    breatheAirRadio: null,
    spO2Input: null,
    textarea: "Dynamic Form Editor is AWESOME!",
  },
};

const elementDemoTemplate = {
  name: "元素 DEMO",
  template: {
    type: "box",
    id: 0,
    contents: [
      {
        type: "box",
        id: 1,
        contents: [
          {
            type: "box",
            id: 2,
            contents: [
              {
                type: "box",
                id: 3,
                contents: [
                  {
                    type: "radioGroup",
                    id: 4,
                    contents: [
                      {
                        type: "radio",
                        id: 5,
                        label: "radio item 1",
                        color: "red",
                      },
                      {
                        type: "radio",
                        id: 6,
                        label: "radio item 2",
                        color: "red",
                      },
                      {
                        type: "radio",
                        id: 7,
                        label: "radio item 3",
                        color: "blue",
                      },
                      {
                        type: "radio",
                        id: 8,
                        label: "radio item 4",
                        color: "purple",
                      },
                    ],
                    bindingKey: "radioGroup",
                    label: "this is radio group label",
                    dense: true,
                  },
                  {
                    type: "separator",
                    id: 9,
                    marginTop: "20px",
                    marginBottom: "20px",
                  },
                ],
                layout: "column",
              },
              {
                type: "box",
                id: 10,
                layout: "column",
                contents: [
                  {
                    type: "select",
                    id: 11,
                    options: [
                      "this-is-select",
                      "this-is-textarea",
                      "this-is-text-field",
                    ],
                    style: "outlined",
                    dense: true,
                    bindingKey: "select",
                  },
                  {
                    type: "separator",
                    id: 12,
                    marginTop: "20px",
                    marginBottom: "20px",
                  },
                ],
              },
              {
                type: "box",
                id: 13,
                layout: "column",
                contents: [
                  {
                    type: "multiSelect",
                    id: 14,
                    dense: true,
                    style: "outlined",
                    bindingKey: "multiSelect",
                    options: ["this", "is", "mutil", "select"],
                  },
                  {
                    type: "separator",
                    id: 15,
                    marginTop: "20px",
                    marginBottom: "20px",
                  },
                ],
              },
              {
                type: "box",
                id: 16,
                layout: "column",
                contents: [
                  {
                    type: "datePicker",
                    id: 17,
                    disabled: false,
                    dense: true,
                    style: "outlined",
                    bindingKey: "datePicker",
                  },
                  {
                    type: "separator",
                    id: 18,
                    marginTop: "20px",
                    marginBottom: "20px",
                  },
                ],
              },
              {
                type: "box",
                id: 19,
                layout: "column",
                contents: [
                  {
                    type: "timeIntervalSelect",
                    id: 20,
                    time: [
                      "21:00",
                      "21:30",
                      "22:00",
                      "22:30",
                      "23:00",
                      "23:30",
                    ],
                    bindingKey: "timeInterval",
                    style: "outlined",
                    dense: true,
                    multiple: "",
                  },
                  {
                    type: "separator",
                    id: 21,
                    marginTop: "20px",
                    marginBottom: "20px",
                  },
                ],
              },
              {
                type: "box",
                id: 22,
                layout: "column",
                contents: [
                  {
                    type: "textarea",
                    id: 23,
                    bindingKey: "textarea",
                    rows: "3",
                    autoGrow: false,
                    noResize: false,
                    style: "outlined",
                    dense: true,
                  },
                  {
                    type: "separator",
                    id: 24,
                    marginTop: "20px",
                    marginBottom: "20px",
                  },
                ],
              },
              {
                type: "box",
                id: 25,
                layout: "column",
                contents: [
                  {
                    type: "chipGroup",
                    id: 26,
                    contents: [
                      {
                        type: "chip",
                        id: 27,
                        color: "red",
                        value: "small",
                        filter: true,
                        outlined: true,
                        textColor: "",
                        size: "small",
                      },
                      {
                        type: "chip",
                        id: 28,
                        color: "",
                        value: "normal",
                        filter: false,
                        outlined: "",
                      },
                      {
                        type: "chip",
                        id: 29,
                        color: "red",
                        value: "tile ",
                        outlined: false,
                        filter: true,
                        textColor: "white",
                        tile: true,
                        size: "normal",
                      },
                      {
                        type: "chip",
                        id: 30,
                        color: "blue",
                        value: "blue-outlined",
                        filter: true,
                        outlined: true,
                      },
                    ],
                    color: "primary",
                    bindingKey: "chipGroup",
                    multiple: true,
                  },
                  {
                    type: "separator",
                    id: 31,
                    marginTop: "20px",
                    marginBottom: "20px",
                  },
                ],
              },
              {
                type: "box",
                id: 32,
                contents: [
                  {
                    type: "box",
                    id: 33,
                    contents: [
                      {
                        type: "icon",
                        id: 34,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 35,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 36,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 37,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 38,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 39,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 40,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 41,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 42,
                        contents: [],
                      },
                      {
                        type: "icon",
                        id: 43,
                        contents: [],
                      },
                    ],
                    layout: "",
                  },
                ],
                layout: "column",
              },
            ],
            layout: "column",
            flexGrow: 1,
          },
        ],
        layout: "",
        wrap: "wrap",
        flexGrow: 1,
      },
    ],
    layout: "",
    flex: "1",
    flexBasis: "100%",
    wrap: "wrap",
  },
  bindingData: {
    select: "this-is-select",
    timeInterval: ["21:30", "22:00", "22:30", "23:00", "23:30", "21:00"],
    datePicker: "2020-10-02",
    multiSelect: ["zxcv", "asdf", "qwer", "this", "is", "mutil", "select"],
    chipGroup: null,
    textarea: "Eureka!!\nthis is textarea!\n",
    radioGroup: "radio item 4",
  },
};

export const templates = {
  tableTemplate,
  elementDemoTemplate,
};

export const bindingData = tableTemplate.bindingData;
export const template = tableTemplate.template;
